import {
  getInitialLanguageCode,
  makeDisplayInformationSchema,
} from 'components/forms/fields/display-information-field/display-information-field.utils';
import { array, object, string } from 'yup';

export const menuDisplayInfoSchema = makeDisplayInformationSchema(
  object({
    title: string().max(100).required(),
    shortDescription: string().max(500).nullable(),
    longDescription: string().max(1000).nullable(),
    smallImage: array().of(string().nullable()).multipleImages().nullable(),
    mediumImage: array().of(string().nullable()).multipleImages().nullable(),
  }),
  [
    {
      languageCode: getInitialLanguageCode(
        navigator.language.split('-')[0].toUpperCase(),
      ),
      title: '',
      shortDescription: '',
      longDescription: '',
      smallImage: [],
      mediumImage: [],
    },
  ],
);
